import { createAction } from 'redux-actions';

import types from './types';

const setLoading = createAction(types.SET_LOADING);
const createWishlist = createAction(types.CREATE_WISHLIST);
const loadWishlist = createAction(types.LOAD_WISHLIST);
const addToWishlist = createAction(types.ADD_TO_WISHLIST);
const addToSelectedWishlist = createAction(types.ADD_TO_SELECTED_WISHLIST);
const removeFromWishlist = createAction(types.REMOVE_FROM_WISHLIST);
const updateWishlist = createAction(types.UPDATE_WISHLIST);
const updateSharedWishlist = createAction(
    types.UPDATE_SHARED_WISHLIST,
    (productCode, quantity) => ({ productCode, quantity }),
);
const updatePersonalWishlist = createAction(
    types.UPDATE_PERSONAL_WISHLIST,
    (productCode, quantity) => ({ productCode, quantity }),
);
const setWishlist = createAction(types.SET_WISHLIST);
const setSharedWishlist = createAction(types.SET_SHARED_WISHLIST);
const addToCart = createAction(types.ADD_TO_CART);
const loadSelectedWishlist = createAction(types.LOAD_SELECTED_WISHLIST);
const loadNewWishlist = createAction(types.LOAD_NEW_WISHLIST);
const shareWishlist = createAction(types.SHARE_WISHLIST);
const loadingFinished = createAction(types.LOADING_FINISHED);
const filterWishlist = createAction(types.FILTER_WISHLIST);
const setWishlistFilter = createAction(types.SET_FILTER);
const setNewWishlistData = createAction(types.SET_NEW_WISHLIST_DATA);
const resetNewWishlistData = createAction(types.RESET_NEW_WISHLIST_DATA);
const removeWishlist = createAction(types.REMOVE_WISHLIST);
const setInitial = createAction(types.SET_INITIAL);
const setPendingProduct = createAction(types.SET_PENDING_PRODUCT);
const removePendingFromWishlist = createAction(types.REMOVE_PENDING_FROM_WISHLIST);
const renameWishlist = createAction(types.RENAME_WISHLIST);
const setNewWishlistAnalyticsData = createAction(types.SET_NEW_WISHLIST_ANALYSTICS_DATA);
const considerMemberPriceForTotal = createAction(types.CALCULATE_TOTAL_WITH_MEMBER_PRICE);
const setErrorWhileAddToWishlist = createAction(types.SET_ERROR_WHILE_ADD_TO_WISHLIST);
const openShareWishlistDialog = createAction(types.OPEN_SHARE_WISHLIST_DIALOG);
const setErrorStateForSharedWishlist = createAction(types.SET_ERROR_STATE_FOR_SHARED_WISHLIST);
const setLightWishlist = createAction(types.SET_LIGHT_WISHLIST);
const loadLightWishlist = createAction(types.LOAD_LIGHT_WISHLIST);

export default {
    setLoading,
    createWishlist,
    loadWishlist,
    loadingFinished,
    addToWishlist,
    addToSelectedWishlist,
    removeFromWishlist,
    updateWishlist,
    updatePersonalWishlist,
    updateSharedWishlist,
    setWishlist,
    setSharedWishlist,
    loadSelectedWishlist,
    loadNewWishlist,
    setNewWishlistData,
    resetNewWishlistData,
    shareWishlist,
    addToCart,
    filterWishlist,
    setWishlistFilter,
    removeWishlist,
    setInitial,
    setPendingProduct,
    removePendingFromWishlist,
    renameWishlist,
    setNewWishlistAnalyticsData,
    considerMemberPriceForTotal,
    setErrorWhileAddToWishlist,
    openShareWishlistDialog,
    setErrorStateForSharedWishlist,
    setLightWishlist,
    loadLightWishlist,
};
